module.exports = __webpack_public_path__ + "img/service_img.f943d9c7.jpg";